<div class="approvals-section">
  <core-title-section
    [title]="'APPROVALS'"
  ></core-title-section>

  <article class="approvals-main">
    <app-helpers-search-bar-main
      [placeholder]="'Search the approvals'"
      [term]="term"
      [filters]="appliedFilters"
      (termChanges)="onSetTerm($event)"
      (removeFilter)="onRemove($event)"
    ></app-helpers-search-bar-main>

    <approvals-search-filters></approvals-search-filters>
  </article>
</div >
